"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _raffle = require("@/api/raffle.js");
var _auth = require("@/utils/auth");
var _common = require("../../store/creatStore/common.js");
var _componentsApi = require("@/api/componentsApi");
var _constants = require("@/utils/constants");
var XLSX = _interopRequireWildcard(require("xlsx"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    cloneForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      constants: this.$constants,
      test: null,
      //参数
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keyword: '',
        // 新增
        customerId: null,
        // 新增
        status: null,
        // 新增
        lotteryStatus: null,
        // 新增
        dateList: null // 新增
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: true,
      dialogVisible: false,
      form: {},
      titleType: false,
      disPopup: false,
      popupLottery: {},
      lotteryId: null,
      miniCodeList: []
    };
  },
  mounted: function mounted() {
    this.handleRueApi();
    this.handleMiniCode();
  },
  methods: {
    handleRueApi: function () {
      var _handleRueApi = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _raffle.prizeDrawNewList)(this.listPram);
            case 1:
              res = _context.v;
              this.listData = res;
              this.listLoading = false;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function handleRueApi() {
        return _handleRueApi.apply(this, arguments);
      }
      return handleRueApi;
    }(),
    handleMiniCode: function () {
      var _handleMiniCode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return (0, _raffle.companyappAutoListApi)();
            case 1:
              res = _context2.v;
              console.log(res, 'res');
              this.miniCodeList = res;
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function handleMiniCode() {
        return _handleMiniCode.apply(this, arguments);
      }
      return handleMiniCode;
    }(),
    handlePopup: function handlePopup() {
      this.form = {};
      this.dialogVisible = true;
      this.titleType = true;
    },
    //添加店铺
    handleSubmitEdit: function () {
      var _handleSubmitEdit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              _context3.n = 1;
              return saveOrUpdate(_objectSpread(_objectSpread({}, this.form), {}, {
                status: Number(this.form.status)
              }));
            case 1:
              this.dialogVisible = false;
              this.$message.success(this.titleType ? '添加成功' : ' 修改成功');
              this.handleRueApi();
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t2 = _context3.v;
              this.$message.error('添加失败');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handleSubmitEdit() {
        return _handleSubmitEdit.apply(this, arguments);
      }
      return handleSubmitEdit;
    }(),
    //编辑
    openOrderDetailEdit: function openOrderDetailEdit(row) {
      this.lotteryId = row.id;
      this.form = _objectSpread({}, row);
      this.disPopup = true;
    },
    handleSubmitLottery: function () {
      var _handleSubmitLottery = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _raffle.prizeDrawNewUpdate)(_objectSpread({}, this.form));
            case 1:
              this.$message.success('开奖成功！');
              this.disPopup = false;
              this.handleRueApi();
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t3 = _context4.v;
              this.$message.error(_t3.message);
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handleSubmitLottery() {
        return _handleSubmitLottery.apply(this, arguments);
      }
      return handleSubmitLottery;
    }(),
    handleExprot: function () {
      var _handleExprot = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res, worksheetData, worksheet, workbook, excelBuffer, dataBlob, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return (0, _raffle.prizeDrawNewList)(_objectSpread(_objectSpread({}, this.listPram), {}, {
                limit: 0,
                page: 0
              }));
            case 1:
              res = _context5.v;
              // 数据转换
              worksheetData = res.list.map(function (item) {
                return {
                  id: item.id,
                  抽奖名称: item.lotteryName,
                  参与人姓名: item.userName,
                  参与人手机号: item.userPhone,
                  小程序渠道: item.customerName,
                  中奖结果: item.winningName,
                  中奖内容: item.remark,
                  收货地址: item.address
                };
              }); // 创建工作簿
              worksheet = XLSX.utils.json_to_sheet(worksheetData);
              workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, '用户提交信息');

              // 生成Excel文件
              excelBuffer = XLSX.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
              }); // 文件下载
              dataBlob = new Blob([excelBuffer], {
                type: 'application/octet-stream'
              });
              saveAs(dataBlob, "\u7528\u6237\u63D0\u4EA4\u4FE1\u606F_".concat(new Date().getTime(), ".xlsx"));
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              this.$message.error(_t4.message);
            case 3:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function handleExprot() {
        return _handleExprot.apply(this, arguments);
      }
      return handleExprot;
    }(),
    handleReset: function handleReset() {
      this.listPram.keyword = '';
      this.listPram.customerId = null;
      this.listPram.status = null;
      this.listPram.lotteryStatus = null;
      this.listPram.dateList = null;
      this.handleRueApi();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handleRueApi(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handleRueApi(this.listPram);
    }
  }
};